import React from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import {
  CardMedia,
  Chip,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

const imageUrl =
  "https://res.cloudinary.com/dtqbxfe7r/image/upload/v1721794614/teacher-noblue_enhpgz.svg";
const AjarnHowToHelper = () => {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={0}
      sx={{
        background: "transparent",
        borderRadius: 5,
        padding: 2,
        margin: "0 auto 1rem",
      }}
    >
      <Stack
        sx={{ flexDirection: { xs: "column", md: "row" } }}
        alignItems="center"
        spacing={2}
      >
        <Stack sx={{ width: { xs: "100%", md: "100%" } }} alignItems="start">
          <Typography variant="h4" color="text.secondary">
            {t("home.howToHelper.title")}
          </Typography>
          <Typography gutterBottom variant="subtitle1" color="text.secondary">
            {t("home.howToHelper.body")}
          </Typography>
        </Stack>
        <Divider
          orientation="vertical"
          sx={{ width: 20, margin: "0.5rem !important" }}
          flexItem
        />
        <Stack>
          <CardMedia
            sx={{ width: { xs: "100%", md: "75%" }, margin: "0 auto" }}
            component="img"
            src={imageUrl}
            alt="get-started-ajarn-jobs"
          />
          <Divider sx={{ margin: "0.5rem auto", width: "80%" }} />
          <Chip
            variant="contained"
            color="primary"
            component={Link}
            clickable
            label={t("home.howToHelper.cta")}
            to="/how-to-use-ajarn-jobs"
          />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default AjarnHowToHelper;
